import { Outlet, useLocation } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Layout = () => {
  const location = useLocation();
  const reduce = useReducedMotion();
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      {/* Centre content site-wide from the one shell every route flows through.
          text-center only shifts text-align, so mx-auto containers and the
          flex/grid page layouts keep their structure — a page that needs
          left-aligned copy overrides locally. */}
      <main className="flex-1 text-center">
        {/* Re-keying on the path remounts the page, so the entrance replays on
            every navigation. Reduced-motion renders straight to the resting
            state — no fade, no rise. */}
        <motion.div
          key={location.pathname}
          initial={reduce ? false : { opacity: 0, y: 12 }}
          animate={reduce ? undefined : { opacity: 1, y: 0 }}
          transition={reduce ? undefined : { duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
        >
          <Outlet />
        </motion.div>
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
